import { useState, createContext, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const CartContext = createContext({
	cartItems: [],
	addProduct: () => {},
	removeProduct: () => {},
	itemInCart: () => {},
	changeQuantity: () => {},
	emptyCart: () => {},
});

function CartContextProvider(props) {
	const [cart, setCart] = useState([]);
	const cart_string = JSON.stringify(cart);
	// this is to check if the component has had its initial loading
	const [initialized, setInitialized] = useState(false);

	useEffect(
		() => {
			// on initial load, retrieve products from cache
			const store = localStorage.getItem("products");
			if (store) {
				const parsed_data = JSON.parse(store);
				setCart(parsed_data);
			}
			setInitialized(true);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	useEffect(() => {
		if (!initialized) {
			return;
			// this is to ensure that the data in local storage is not overwritten when the component is reloaded
		}

		localStorage.setItem("products", cart_string);
	}, [cart_string, initialized]);

	const addProduct = useCallback(
		(id, quantity, size) => {
			toast.success("Product added to cart");
			const [...cart_copy] = cart;
			const id_index = cart_copy.findIndex(
				(item) => item.id === id && item.size === size
			);
			if (id_index >= 0) {
				throw new Error("Item Already in Cart");
			}
			cart_copy.push({ id, quantity, size });
			setCart(cart_copy);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[cart_string]
	);

	const changeQuantity = useCallback(
		(id, quantity, size) => {
			const [...cart_copy] = cart;
			const id_index = cart_copy.findIndex(
				(item) => item.id === id && item.size === size
			);
			if (id_index === -1) {
				return;
			}
			cart_copy[id_index].quantity = quantity;
			console.log(cart_copy);
			setCart(cart_copy);
		}, // eslint-disable-next-line react-hooks/exhaustive-deps
		[cart_string]
	);

	const removeProduct = useCallback(
		(id, size) => {
			toast.success("Product removed from cart");
			const [...cart_copy] = cart;
			const product_index = cart_copy.findIndex(
				(item) => item.id === id && item.size === size
			);
			if (product_index === -1) {
				console.log(id, size);
				throw new Error("Item doesn't exist!");
			}
			cart_copy.splice(product_index, 1);
			setCart(cart_copy);
		}, // eslint-disable-next-line react-hooks/exhaustive-deps
		[cart_string]
	);

	const emptyCart = useCallback(() => {
		setCart([]);
		localStorage.setItem("products", []);
	}, []);

	return (
		<CartContext.Provider
			value={{
				addProduct,
				removeProduct,
				changeQuantity,
				emptyCart,
				cartItems: cart,
			}}
		>
			{props.children}
		</CartContext.Provider>
	);
}
export default CartContextProvider;
